/**
 * Copyright © 2018 Emu Analytics
 */

import { ILoginResponse, ITokenRefreshResponse } from './api-interfaces';
import { Client } from './client';
import { UserEndpoint } from './user.endpoints';

export class AuthEndpoints {
  users = new UserEndpoint(this.client);

  constructor(private readonly client: Client) {}

  login(email: string, password: string, applicationId?: string): Promise<ILoginResponse> {
    return this.client._post('/api/v1/auth/login', { email, password, applicationId });
  }

  logout(accessToken: string, refreshToken: string): Promise<void> {
    return this.client._post(
      '/api/v1/auth/logout',
      { refreshToken },
      {
        headers: { Authorization: `Bearer ${accessToken}` }
      }
    );
  }

  refresh(refreshToken: string, applicationId: string): Promise<ITokenRefreshResponse> {
    return this.client._post('/api/v1/auth/refresh', { refreshToken, applicationId });
  }

  changePassword(password: string, newPassword: string, token: string): Promise<void> {
    return this.client._post(
      '/api/v1/auth/changepassword',
      {
        password,
        newPassword
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
  }

  signUp(
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    applicationId: string,
    confirmUrl: string,
    redirectUrl?: string
  ): Promise<void> {
    // Support legacy signature, which was missing confirmUrl
    if (!redirectUrl) {
      redirectUrl = confirmUrl;
      confirmUrl = `${this.client.baseUrl}/api/v1/auth/confirmsignup`;
    }

    return this.client._post('/api/v1/auth/signup', {
      firstName,
      lastName,
      email,
      password,
      applicationId,
      confirmUrl,
      redirectUrl
    });
  }

  confirmSignUp(email: string, token: string, redirect?: string): Promise<void> {
    return this.client._get(`/api/v1/auth/confirmsignup`, { params: { email, token, redirect } });
  }

  requestPasswordReset(email: string, applicationId: string, redirectUrl: string): Promise<void> {
    return this.client._post('/api/v1/auth/requestpasswordreset', { email, applicationId, redirectUrl });
  }

  resetPassword(email: string, password: string, applicationId: string, token: string): Promise<void> {
    return this.client._post('/api/v1/auth/resetpassword', { email, password, applicationId, token });
  }
}
